"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.195 3.012c.118-.014.376-.044.579.11l13.791 8.06.034.03c.156.136.401.35.401.75 0 .402-.245.616-.4.752l-.01.01-.025.02-13.788 8.058C6.532 21 6.272 21 6.12 21h-.025c-.064 0-.19 0-.302-.032a.492.492 0 0 1-.226-.135.756.756 0 0 1-.39-.27.904.904 0 0 1-.176-.545V3.908c0-.183.051-.383.175-.546a.77.77 0 0 1 .626-.302c.08 0 .145-.01.23-.024l.164-.024Zm1.02 15.093V5.68l10.666 6.151-10.666 6.274Z",
    clipRule: "evenodd"
  })]
});